<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form :inline="true" :model="dataForm">
      <el-form-item><el-input v-model="dataForm.username" placeholder="用户名" clearable /></el-form-item>
      <el-form-item><el-input v-model="dataForm.nickname" placeholder="昵称" clearable /></el-form-item>
      <el-form-item>
        <el-select
          v-model="dataForm.parentId"
          filterable
          remote
          clearable
          :remote-method="searchAgents"
          :loading="agentLoading"
          placeholder="请输入上级代理用户名"
          style="width: 260px;">
          <el-option
            v-for="agent in agentOptions"
            :key="agent.id"
            :label="agentLabel(agent)"
            :value="agent.id" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="dataForm.level" :true-label="1" :false-label="null">
          仅显示顶级
        </el-checkbox>
      </el-form-item>
      <el-form-item><el-select v-model="dataForm.status" placeholder="状态" clearable><el-option label="启用" :value="1"/><el-option label="禁用" :value="2"/></el-select></el-form-item>
      <el-form-item><el-button @click="search">查询</el-button><el-button type="primary" @click="openEditor()">新增</el-button></el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="dataList" border>
      <el-table-column prop="id" label="ID" width="80" align="center"/>
      <el-table-column prop="username" label="用户名"/><el-table-column prop="nickname" label="昵称"/>
      <el-table-column prop="member_code" label="邀请码"/>
      <el-table-column prop="parentUsername" label="上级代理"/>
      <el-table-column prop="level" label="等级" width="70" align="center"/>
      <el-table-column prop="commissionRatio" label="返佣比例" width="100" align="center">
        <template slot-scope="s">{{ s.row.commissionRatio }}%</template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center"><template slot-scope="s"><el-tag :type="statusType(s.row.status)">{{ statusText(s.row.status) }}</el-tag></template></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170"/>
      <el-table-column label="操作" fixed="right" width="290" align="center"><template slot-scope="s"><el-button type="text" @click="viewSubAgents(s.row)">查看</el-button><el-button type="text" @click="openEditor(s.row)">编辑</el-button><el-button type="text" @click="changeRatio(s.row)">返佣比例</el-button><el-button type="text" @click="toggleStatus(s.row)">{{ s.row.status === 1 ? '禁用' : '启用' }}</el-button><el-button type="text" @click="resetPassword(s.row)">重置密码</el-button></template></el-table-column>
    </el-table>
    <el-pagination :current-page="page" :page-size="limit" :page-sizes="[10,20,50,100]" :total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChange" @current-change="currentChange"/>
    <el-dialog :title="form.id ? '编辑代理' : '新增代理'" :visible.sync="editorVisible" width="520px">
      <el-form v-loading="commissionLoading" ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" :disabled="!!form.id" />
        </el-form-item>
        <el-form-item v-if="!form.id" label="密码" prop="password">
          <el-input v-model="form.password" type="password" />
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.nickname" />
        </el-form-item>
        <el-form-item v-if="!form.id" label="上级代理">
          <el-select
            v-model="form.parentId"
            filterable
            remote
            clearable
            :remote-method="searchParentAgents"
            :loading="parentAgentLoading"
            placeholder="请输入代理用户名搜索"
            style="width: 100%;">
            <el-option label="无（创建一级代理）" :value="0" />
            <el-option
              v-for="agent in parentAgentOptions"
              :key="agent.id"
              :label="parentAgentLabel(agent)"
              :value="agent.id"
              :disabled="agent.level === 3" />
          </el-select>
        </el-form-item>
        <el-form-item label="返佣比例" prop="commissionRatio">
          <el-input-number v-model="form.commissionRatio" :min="0" :max="100" /> %
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="2"
            active-text="启用"
            inactive-text="禁用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button :disabled="submitting" @click="editorVisible = false">取消</el-button>
        <el-button
          type="primary"
          :disabled="commissionLoading"
          :loading="submitting"
          @click="submit">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="重置密码" :visible.sync="passwordVisible" width="520px">
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="100px">
        <el-form-item label="新密码" prop="password">
          <el-input
            v-model="passwordForm.password"
            placeholder="密码至少6位，需包含数字和字母"
            maxlength="32">
            <el-button slot="append" @click="generateAndCopyPassword">随机生成并复制</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button :disabled="passwordSubmitting" @click="passwordVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="passwordSubmitting"
          @click="submitResetPassword">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="下级代理"
      :visible.sync="subAgentVisible"
      width="900px">
      <div class="agent-detail-header">
        <div class="agent-detail-avatar">
          {{ agentAvatar }}
        </div>
        <div>
          <div class="agent-detail-name">
            {{ selectedAgent.nickname || '-' }}（{{ selectedAgent.username || '-' }}）
          </div>
          <div class="agent-detail-tags">
            <el-tag size="small">代理</el-tag>
            <el-tag
              size="small"
              :type="statusType(selectedAgent.status)">
              {{ statusText(selectedAgent.status) }}
            </el-tag>
          </div>
        </div>
      </div>
      <div class="sub-agent-summary">
        下级代理 <strong>{{ subAgentTotal }}</strong> 人
      </div>
      <el-table
        v-loading="subAgentLoading"
        :data="subAgentList"
        border
        empty-text="暂无下级代理">
        <el-table-column prop="id" label="ID" width="90" align="center" />
        <el-table-column prop="username" label="账号" />
        <el-table-column prop="nickname" label="昵称" />
        <el-table-column prop="member_code" label="邀请码" />
        <el-table-column prop="level" label="代理等级" width="100" align="center" />
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusType(scope.row.status)" size="small">
              {{ statusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="返佣比例" width="110" align="center">
          <template v-slot="scope">
            {{ scope.row.commissionRatio }}%
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="subAgentPage"
        :page-size="subAgentLimit"
        :page-sizes="[10, 20, 50]"
        :total="subAgentTotal"
        layout="total, sizes, prev, pager, next"
        @size-change="subAgentSizeChange"
        @current-change="subAgentCurrentChange" />
      <span slot="footer">
        <el-button type="primary" @click="subAgentVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import agentPage from '@/mixins/agent-page'

const emptyForm = () => ({
  id: '',
  username: '',
  password: '',
  nickname: '',
  parentId: 0,
  commissionRatio: 0,
  status: 1
})

export default {
  mixins: [agentPage],
  data () {
    return {
      pageUrl: '/agent/page',
      dataForm: {
        username: '',
        nickname: '',
        parentId: '',
        level: 1,
        status: ''
      },
      editorVisible: false,
      form: emptyForm(),
      submitting: false,
      passwordSubmitting: false,
      commissionLoading: false,
      parentAgentLoading: false,
      parentAgentOptions: [],
      passwordVisible: false,
      passwordForm: {
        agentId: '',
        password: ''
      },
      subAgentVisible: false,
      subAgentLoading: false,
      selectedAgent: {},
      subAgentList: [],
      subAgentPage: 1,
      subAgentLimit: 10,
      subAgentTotal: 0,
      passwordRules: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          {
            pattern:  /^(?=.*\d)(?=.*[A-Za-z]).{6,}$/, ///^(?=.*\d)(?=.*[A-Za-z])[A-Za-z\d]{6,}$/,
            message: '密码至少6位，且必须同时包含数字和字母',
            trigger: 'blur'
          }
        ]
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        commissionRatio: [
          { required: true, message: '请输入返佣比例', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    agentAvatar () {
      const name = this.selectedAgent.nickname || this.selectedAgent.username || '代'
      return name.charAt(0).toUpperCase()
    }
  },
  methods: {
    openEditor (row) {
      this.form = row ? { ...emptyForm(), ...row } : emptyForm()
      this.parentAgentOptions = []
      this.editorVisible = true
      if (!row) {
        this.loadGlobalCommission()
      }
    },
    loadGlobalCommission () {
      this.commissionLoading = true
      this.$http.get('/agent_config').then(({ data }) => {
        if (data.code !== 0) {
          return this.$message.error(data.msg)
        }
        const commission = data.data !== null && typeof data.data === 'object'
          ? data.data.commissionRatio
          : data.data
        this.form.commissionRatio = Number(commission || 0)
      }).finally(() => {
        this.commissionLoading = false
      })
    },
    searchParentAgents (username) {
      const keyword = username.trim()
      if (!keyword) {
        this.parentAgentOptions = []
        return
      }

      this.parentAgentLoading = true
      this.$http.get('/agent/page', {
        params: {
          username: keyword,
          page: 1,
          limit: 20
        }
      }).then(({ data }) => {
        if (data.code !== 0) {
          this.parentAgentOptions = []
          return this.$message.error(data.msg)
        }
        this.parentAgentOptions = data.data.list || []
      }).finally(() => {
        this.parentAgentLoading = false
      })
    },
    parentAgentLabel (agent) {
      const nickname = agent.nickname ? ` - ${agent.nickname}` : ''
      return `${agent.username}${nickname}（ID: ${agent.id}）`
    },
    submit () {
      // 请求没回来之前不再发第二次，避免重复新增
      if (this.submitting) {
        return
      }
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }

        this.submitting = true
        const request = this.form.id
          ? this.$http.put(`/agent/${this.form.id}`, this.form)
          : this.$http.post('/agent', this.form)

        request.then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.$message.success('保存成功')
          this.editorVisible = false
          this.getDataList()
        }).catch(() => {}).finally(() => {
          this.submitting = false
        })
      })
    },
    changeRatio (row) {
      this.$prompt('请输入0-100的返佣比例', '设置返佣比例', {
        inputValue: row.commissionRatio,
        inputPattern: /^(100|\d{1,2})(\.\d+)?$/,
        inputErrorMessage: '返佣比例必须在0-100之间'
      }).then(({ value }) => {
        return this.$http.put(`/agent/${row.id}/commission-ratio`, {
          commissionRatio: Number(value)
        })
      }).then(({ data }) => {
        if (data.code !== 0) {
          return this.$message.error(data.msg)
        }
        this.$message.success('保存成功')
        this.getDataList()
      }).catch(() => {})
    },
    toggleStatus (row) {
      const status = row.status === 1 ? 2 : 1

      this.$confirm(`确认${status === 1 ? '启用' : '禁用'}该代理？`, '提示')
        .then(() => {
          return this.$http.put(`/agent/${row.id}/status`, { status })
        })
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.getDataList()
        })
        .catch(() => {})
    },
    viewSubAgents (row) {
      this.selectedAgent = { ...row }
      this.subAgentPage = 1
      this.subAgentVisible = true
      this.getSubAgentList()
    },
    getSubAgentList () {
      this.subAgentLoading = true
      this.$http.get('/agent/page', {
        params: {
          parentId: this.selectedAgent.id,
          page: this.subAgentPage,
          limit: this.subAgentLimit
        }
      }).then(({ data }) => {
        if (data.code !== 0) {
          this.subAgentList = []
          this.subAgentTotal = 0
          return this.$message.error(data.msg)
        }
        this.subAgentList = data.data.list || []
        this.subAgentTotal = data.data.total || 0
      }).finally(() => {
        this.subAgentLoading = false
      })
    },
    subAgentSizeChange (value) {
      this.subAgentPage = 1
      this.subAgentLimit = value
      this.getSubAgentList()
    },
    subAgentCurrentChange (value) {
      this.subAgentPage = value
      this.getSubAgentList()
    },
    resetPassword (row) {
      this.passwordForm = {
        agentId: row.id,
        password: ''
      }
      this.passwordVisible = true
      this.$nextTick(() => {
        this.$refs.passwordForm.clearValidate()
      })
    },
    generateAndCopyPassword () {
      const letters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
      const numbers = '23456789'
      const characters = letters + numbers
      const passwordCharacters = [
        letters[Math.floor(Math.random() * letters.length)],
        numbers[Math.floor(Math.random() * numbers.length)]
      ]

      while (passwordCharacters.length < 8) {
        passwordCharacters.push(
          characters[Math.floor(Math.random() * characters.length)]
        )
      }

      const password = passwordCharacters
        .sort(() => Math.random() - 0.5)
        .join('')

      this.passwordForm.password = password
      this.copyPassword(password)
    },
    copyPassword (password) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(password).then(() => {
          this.$message.success('已生成8位密码并复制')
        }).catch(() => {
          this.copyPasswordFallback(password)
        })
        return
      }
      this.copyPasswordFallback(password)
    },
    copyPasswordFallback (password) {
      const input = document.createElement('textarea')
      input.value = password
      input.setAttribute('readonly', '')
      input.style.position = 'fixed'
      input.style.opacity = '0'
      document.body.appendChild(input)
      input.select()
      const copied = document.execCommand('copy')
      document.body.removeChild(input)

      if (copied) {
        this.$message.success('已生成8位密码并复制')
      } else {
        this.$message.warning('已生成8位密码，请手动复制')
      }
    },
    submitResetPassword () {
      if (this.passwordSubmitting) {
        return
      }
      this.$refs.passwordForm.validate(valid => {
        if (!valid) {
          return
        }

        this.passwordSubmitting = true
        this.$http.put(
          `/agent/${this.passwordForm.agentId}/reset-password`,
          null,
          { params: { password: this.passwordForm.password } }
        ).then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.$message.success('密码已重置')
          this.passwordVisible = false
        }).catch(() => {}).finally(() => {
          this.passwordSubmitting = false
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.agent-detail-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.agent-detail-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-right: 14px;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  background: #409eff;
  border-radius: 50%;
}

.agent-detail-name {
  margin-bottom: 8px;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.agent-detail-tags .el-tag + .el-tag {
  margin-left: 8px;
}

.sub-agent-summary {
  margin-bottom: 14px;
  padding: 12px 16px;
  color: #606266;
  background: #f5f7fa;
  border-radius: 4px;
}

.sub-agent-summary strong {
  margin: 0 4px;
  color: #409eff;
  font-size: 18px;
}
</style>
